import React, { useEffect, useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import PlayCricket from '../assets/images/banner1.png'
import Tanis from '../assets/images/banner2.png'
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
// import required modules
import { FreeMode, Autoplay } from 'swiper/modules';
import AuthService from '../services/auth.service';
import { Link, useNavigate } from 'react-router-dom';
import Helpers from '../services/helpers';
import { now } from 'moment';


export default function Livecasino() {
  const swiperRef = useRef<any>(null); // Create a ref for the swiper instance
  const [activeButton, setActiveButton] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [isPageloading, setIsPageLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [gameList, setGameList] = useState<any>([]);
  const navigate = useNavigate();

  const goNext = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slideNext();
      setActiveButton('next');
    }
  };

  const goPrev = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slidePrev();
      setActiveButton('prev');
    }
  };

  useEffect(() => {
    getGamesList();
    
    // eslint-disable-next-line
  }, []);

  function getGamesList() {
    AuthService.getGameCasino('casino', 'fetch_games')
      .then(
        (response) => {
          //console.log(response);
          if (response.status === 200) {
            setGameList(response?.data?.items);
          } else {
            setMessage(response?.message);
          }
        }
      ).catch((error) => {
        // console.log(error?.status, error?.response?.data?.status)
        const message = error?.response?.data?.error_description;
        setMessage(message);
        if (error?.response?.data?.status === 401) {
          localStorage.removeItem("w_token");
          navigate('/login');
        }
      }).finally(() => {
        setIsPageLoading(false);
      });
  }

  return (
    <>
      <div className="row d-flex align-items-center">
        <div className="col-7 castom_m-y">
          <h1 className='mainTital d-flex justify-content-start align-items-center'>Live Casino 🎰</h1>
        </div>
        <div className="col-5 castom_m-y text-end d-flex justify-content-end align-items-center">
          <h3 className='sumTital me-1'>
            All
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none" style={{ marginLeft: 1 }}>
              <path d="M7.84443 6.73748L4.36392 10.2179L5.35833 11.2123L9.83325 6.73748L5.35833 2.26256L4.36392 3.25697L7.84443 6.73748Z" fill="#CCCCCC" />
            </svg>
          </h3>
          <button className={`custom-prev ${activeButton === 'prev' ? 'sportActive' : ''} me-1`}
            onClick={goPrev}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
              <path d="M7.20779 6.68305L10.9369 10.4121L9.87146 11.4775L5.0769 6.68305L9.87146 1.88849L10.9369 2.95393L7.20779 6.68305Z" fill="#CCCCCC" />
            </svg>
          </button>
          <button className={`custom-next ${activeButton === 'next' ? 'sportActive' : ''}`}
            onClick={goNext}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
              <path d="M7.94602 6.68305L4.2169 10.4121L5.28234 11.4775L10.0769 6.68305L5.28235 1.88849L4.2169 2.95393L7.94602 6.68305Z" fill="#CCCCCC" />
            </svg>
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <Swiper
            ref={swiperRef}
            modules={[Autoplay, FreeMode]}
            autoplay={false}
            loop={false}
            // speed={300}
            breakpoints={{
              768: {
                slidesPerView: 2,  
              },
              1024: {
                slidesPerView: 4, 
              },
            }}
            slidesPerView={2}
            spaceBetween={12}
            freeMode={true}
            //onReachEnd={() => { console.log("reacth end") }}
          >
            {gameList && gameList.map((key: any, index: number) => (
              <SwiperSlide key={index}>
                <div className='casino'>
                  {Helpers.getTokenData()?.access_token ?
                    (
                      <Link to={`/play-game/${key?.uuid}`}>
                        <img src={AuthService?.baseUrlImage+'public/storage/thumbnails/'+key?.image} alt={key?.name} className='img-fluid' />
                      </Link>
                    ) : (
                      <Link to={`/login`}>
                        <img src={AuthService?.baseUrlImage+'public/storage/thumbnails/'+key?.image} alt={key?.name} className='img-fluid' />
                      </Link>
                    )
                  }

                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </>
  );
}
